export const P00058AmorcageTimerEnum = (t: any) => {
  let res = [];

  for (let i = 2; i <= 30; i = i + 2) {
    res.push({ ref: i, label: i + ' ' + t.instant('time.minut') });
  }

  return res;
};
